module.exports = __webpack_public_path__ + "static/media/example-2.f2eb1b60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/EnableWA/example-2.jpg
// module id = 239
// module chunks = 0